import { Mail } from 'lucide-react'
import { COMPANY } from '../lib/format'

export default function Maintenance() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-navy-950 px-6" data-testid="maintenance-page">
      <div className="text-center max-w-md">
        <div className="mx-auto w-16 h-16 bg-gradient-to-br from-brand-orange to-red-600 rounded-2xl flex items-center justify-center font-display font-bold text-3xl text-white shadow-lg shadow-orange-500/30">CS</div>
        <p className="mt-4 font-display text-3xl tracking-wider font-bold text-white">CARPER<span className="text-brand-orange">SPORTS</span></p>
        <h1 className="mt-8 font-display text-2xl sm:text-3xl font-bold text-white uppercase">Site en cours de maintenance</h1>
        <p className="mt-3 text-slate-400 text-sm">Nous revenons très vite. Pour toute question, écrivez-nous :</p>
        <a href={`mailto:${COMPANY.email}`} className="mt-5 inline-flex items-center gap-2 px-5 py-3 rounded-xl bg-brand-ink text-white font-bold text-sm hover:bg-orange-800 transition-colors" data-testid="maintenance-email-link"><Mail className="w-4 h-4" /> {COMPANY.email}</a>
      </div>
    </div>
  )
}
